import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.itemsToShow.length ? _c('div', [_vm.link.label ? _c('ProfileTitle', {
    attrs: {
      "link": {
        label: _vm.link.label
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ProfileLinkWrapper', {
    attrs: {
      "threshold": 0
    },
    on: {
      "event": function ($event) {
        return _vm.$emit('event', $event);
      }
    }
  }, [_c('div', {
    staticClass: "v-image-grid"
  }, [_vm.gridOptions.show_message ? _c('p', {
    staticClass: "v-image-grid__text",
    class: {
      'v-image-grid__text--has-title': _vm.link.label
    }
  }, [_vm._v("\n        " + _vm._s(_vm.gridOptions.message) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-image-grid__grid"
  }, [_vm._l(_vm.itemsToShow, function (item, i) {
    return _c('GridItem', _vm._b({
      key: item._id ? item._id.$oid : item.id,
      ref: "gridItemRefs",
      refInFor: true,
      style: "order: " + i,
      attrs: {
        "item": item,
        "disable-multiple-urls": _vm.disableMultipleUrls,
        "selected": _vm.selectedItem && _vm.selectedItem._id.$oid === item._id.$oid,
        "inactive": _vm.selectedItem && _vm.selectedItem._id.$oid !== item._id.$oid,
        "showTapAnimation": i === 1 && !_vm.isInAdmin,
        "enable-utm-parameters": _vm.enableUtmParameters,
        "utm-medium": _vm.utmMedium,
        "utm-source": _vm.utmSource
      },
      on: {
        "click": function ($event) {
          return _vm.handleClick($event, item, i);
        },
        "event": function ($event) {
          return _vm.$emit('event', $event);
        }
      }
    }, 'GridItem', _vm.$props, false));
  }), _vm._v(" "), _vm.loadingItemsCount >= 0 ? _vm._l(_vm.loadingItemsCount, function (i) {
    return _c('GridLoadingItem', _vm._b({
      key: i,
      style: "order: " + (i + _vm.itemsToShow.length),
      on: {
        "is-in-view": _vm.handleNextPage
      }
    }, 'GridLoadingItem', _vm.$props, false));
  }) : _vm._e(), _vm._v(" "), !_vm.disableMultipleUrls && _vm.selectedItem ? _c('GridItemExpander', _vm._b({
    style: "order: " + _vm.expandOrder,
    attrs: {
      "item": _vm.selectedItem,
      "enable-utm-parameters": _vm.enableUtmParameters,
      "utm-medium": _vm.utmMedium,
      "utm-source": _vm.utmSource
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      },
      "event": function ($event) {
        return _vm.$emit('event', $event);
      },
      "close": _vm.handleExpandClose
    }
  }, 'GridItemExpander', _vm.$props, false)) : _vm._e()], 2)])])], 1) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-77b1d837_0", {
    source: ".v-image-grid__text[data-v-77b1d837]{color:var(--p-text-color);font-weight:400;font-family:var(--p-font-family);font-size:.925rem;line-height:1.5;margin:0 auto .75rem;text-align:center}.v-image-grid__text--has-title[data-v-77b1d837]{margin-top:-.35rem}.v-image-grid__grid[data-v-77b1d837]{display:grid;grid-template-columns:repeat(3,1fr);gap:.25rem}.v-image-grid[data-v-77b1d837] .v-skeleton{border-radius:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-77b1d837";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileImageGrid = __vue_component__;
export { ProfileImageGrid as default };